import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Observable, map } from "rxjs";
import { environment } from '../../../environments/environment';
import {ICompany} from "../models/ICompany";
import { ApiResponse } from '../models/ApiResponse';
import { IComment } from '../models/IComment';

@Injectable({ providedIn: 'root' })
export class CommentService {
    constructor(private _http: HttpClient) {}

    getComments(companyId: string): Observable<IComment[]> {
        return this._http.get<ApiResponse<IComment[]>>(`${environment.apiUrl}/api/comments/${companyId}`).pipe(
            map(res=>res.data)
        );
    }

    getCommentById(commentId: string) : Observable<IComment> {
        return this._http.get<ApiResponse<IComment>>(`${environment.apiUrl}/api/comments/${commentId}`).pipe(
            map(res=>res.data)
        );
    }

    addComment(companyId: string, message: string): Observable<IComment> {
        return this._http.post<ApiResponse<IComment>>(`${environment.apiUrl}/api/comments/${companyId}`, { message }).pipe(
            map(res=>res.data)
        );
    }

    updateComment(commentId: string, message: string): Observable<IComment> {
        return this._http.put<ApiResponse<IComment>>(`${environment.apiUrl}/api/comments/${commentId}`, { message }).pipe(
            map(res=>res.data)
        );
    }

    deleteComment(commentId: string): Observable<void> {
        return this._http.delete<ApiResponse<null>>(`${environment.apiUrl}/api/comments/${commentId}`).pipe(
            map(() => {})
        );
    }
}
